import { CheckboxGroupButtons, FloatingFormItem } from '@/components/_common';
import { WorkOrderTypesFilter } from '@/core/domain/questReport/Reports/DRE/DRE.type';
import { isAppPortocar } from '@/index';
import { Col, Collapse, Typography } from 'antd';
import { useIntl } from 'react-intl';

export default function FinancialDreMoreOptions() {
  const { Title } = Typography;
  const intl = useIntl().formatMessage;

  const workOrderTypeOptions = [
    {
      label: intl({
        id: 'movementWorkOrdersReport.form.budgetType.budget',
      }),
      value: WorkOrderTypesFilter.workOrder,
    },
    {
      label: intl({
        id: 'movementWorkOrdersReport.form.budgetType.assurance',
      }),
      value: WorkOrderTypesFilter.warranty,
    },
    {
      label: intl({
        id: 'movementWorkOrdersReport.form.budgetType.return',
      }),
      value: WorkOrderTypesFilter.return,
    },
    {
      label: intl({
        id: `movementWorkOrdersReport.form.budgetType.${
          isAppPortocar ? 'insideCourtesy' : 'courtesy'
        }`,
      }),
      value: WorkOrderTypesFilter.courtesy,
    },
    {
      label: intl({
        id: 'movementWorkOrdersReport.form.budgetType.totalLoss',
      }),
      value: WorkOrderTypesFilter.totalLoss,
    },
    {
      label: intl({
        id: 'movementWorkOrdersReport.form.budgetType.revision',
      }),
      value: WorkOrderTypesFilter.revision,
    },
  ];

  return (
    <Collapse style={{ margin: '8px 0 ' }}>
      <Collapse.Panel
        header={intl({ id: 'cashFlow.label.moreOptions' })}
        key={1}
      >
        <Col span={24} md={24} lg={18} xxl={13}>
          <Title level={5}>
            {intl({
              id: 'movementWorkOrdersReport.form.budgetType',
            })}
          </Title>

          <FloatingFormItem
            name="workOrderTypesFilter"
            initialValue={[
              WorkOrderTypesFilter.workOrder,
              WorkOrderTypesFilter.return,
              WorkOrderTypesFilter.revision,
            ]}
          >
            <CheckboxGroupButtons options={workOrderTypeOptions} />
          </FloatingFormItem>
        </Col>
      </Collapse.Panel>
    </Collapse>
  );
}
